<template>
  <div class="contact-us full-screen bg-light">
    <div class="wrapper wrapper-full-page section content">
      <div class="pt-4">
        <div class="container">
          <div class="row">
            <div class="col-md-8 offset-md-2 text-center">
              <h2 v-if="errorMsg !== ''" class="text-danger"><span class="ti-alert"></span> {{ errorMsg }}</h2>
              <h2 v-if="successMsg !== ''" class="text-success"><span class="ti-check-box"></span> {{ successMsg }}</h2>
              <p v-if="successMsg !== ''">Μπορείτε να συνδεθείτε στο λογαριασμό σας <router-link :to="{path:'/login'}">εδώ</router-link></p>
              <h3 v-if="loading">Παρακαλώ περιμένετε...</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../api";
export default {
  data() {
    return {
      token: this.$route.params.token,
      errorMsg: "",
      successMsg: "",
      loading: false
    };
  },
  mounted() {
    if (!this.token || this.token === "") {
      this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
      return false;
    }
    this.loading = true;
    Api.send2("POST", "/user/verify/email", {}, this.token)
      .then((response) => {
        this.errorMsg = "";
        this.successMsg = "Η ηλεκτρονική διεύθυνση του λογαριασμού σας επαληθεύτηκε";
      })
      .catch((err) => {
        if (err.code === 400) {
          this.errorMsg = err.msg;
        } else {
          this.errorMsg = 'Ο σύνδεσμος έχει λήξει';
        }
        this.successMsg = "";
      })
      .finally(() => {
        this.loading = false;
        this.$root.deleteLoggedUser();
      });
  }
};
</script>
<style scoped>
</style>
